import { render, staticRenderFns } from "./ReplyRender.vue?vue&type=template&id=81767c54"
import script from "./ReplyRender.vue?vue&type=script&lang=js"
export * from "./ReplyRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports